import { useState } from "react";
import { downloadBlob } from "@/lib/vi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FileDown, FileSpreadsheet, FileText } from "lucide-react";

export const JournalExport = ({ accounts, defaultAccount }) => {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ account_id: "all", date_from: "", date_to: "" });
  const [busy, setBusy] = useState("");
  const go = async (format) => {
    setBusy(format);
    const p = new URLSearchParams({ format, account_id: f.account_id === "all" ? "" : f.account_id, date_from: f.date_from, date_to: f.date_to });
    await downloadBlob(`/cash-transactions/export?${p}`, `journal_tresorerie_${f.date_from || "debut"}_${f.date_to || "fin"}.${format}`);
    setBusy("");
  };
  return (
    <>
      <Button variant="outline" onClick={() => { setF({ ...f, account_id: defaultAccount || "all" }); setOpen(true); }} data-testid="open-journal-export"><FileDown className="h-4 w-4 mr-1.5" />Exporter</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="journal-export-dialog">
          <DialogHeader><DialogTitle className="font-head">Exporter le journal des opérations</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-xs">Compte</Label>
              <Select value={f.account_id} onValueChange={(v) => setF({ ...f, account_id: v })}><SelectTrigger className="mt-1" data-testid="export-account"><SelectValue /></SelectTrigger>
                <SelectContent><SelectItem value="all">Tous les comptes</SelectItem>{accounts.map((a) => <SelectItem key={a.id} value={a.id}>{a.nom}</SelectItem>)}</SelectContent></Select></div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label className="text-xs">Du</Label><Input type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} className="mt-1" data-testid="export-date-from" /></div>
              <div><Label className="text-xs">Au</Label><Input type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} className="mt-1" data-testid="export-date-to" /></div>
            </div>
            <p className="text-[11px] text-slate-500">Dates vides : tout l'historique. L'export inclut le solde d'ouverture, les totaux et le solde de clôture.</p>
          </div>
          <DialogFooter className="gap-2">
            <Button variant="outline" disabled={!!busy} onClick={() => go("pdf")} data-testid="export-pdf"><FileText className="h-4 w-4 mr-1.5" />{busy === "pdf" ? "Export…" : "PDF"}</Button>
            <Button disabled={!!busy} onClick={() => go("xlsx")} className="bg-brand-600 hover:bg-brand-700 text-white" data-testid="export-xlsx"><FileSpreadsheet className="h-4 w-4 mr-1.5" />{busy === "xlsx" ? "Export…" : "Excel"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
